(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .directive('currencyFormat', ['$filter', currencyFormat]);

    function currencyFormat($filter) {
        var directive =  {
            require: 'ngModel',
            scope: {
                default: '&default',
                min: '&min',
                max: '&max'
            },
            link: link
        };

        return directive;

        function link(scope, element, attrs, ngModelController) {
            //convert data from view format to model format
            ngModelController.$parsers.push(function(data) {
                if(typeof data !== 'string') {
                    console.error('You must use a string model value with currency format');
                    return null;
                }

                // Get scope values
                var min = scope.min();
                var max = scope.max();
                var defaultValue = scope.default();
                defaultValue = typeof defaultValue !== 'undefined' ? parseFloat(defaultValue) : null;

                // Remove all non-numerical characters (including commas, but keep decimal point)
                data = data.replace(/[^0-9\.\-]/g,'').replace(/[.](?=.*[.])/g, "");

                // Attempt to convert to number; use default value on failure
                var numberValue = data.length === 0 || isNaN(data) ? defaultValue : parseFloat(data);

                // Limit value according to min and max values
                if(typeof(min) === 'number') numberValue = Math.max(min, numberValue);
                if(typeof(max) === 'number') numberValue = Math.min(max, numberValue);
                return numberValue;
            });

            //convert data from model format to view format
            ngModelController.$formatters.push(function(data) {
                return currencyFormatter(data);
            });

            // Format the field on blur
            element.on('blur', function () {
                ngModelController.$viewValue = currencyFormatter(ngModelController.$modelValue);
                ngModelController.$render();
            });

            function currencyFormatter(value) {
                if (value == null || value === '' || isNaN(value)) {
                    return '';
                }
                // Format as currency but without the dollar sign - just comma separators and 2 decimal places
                return $filter('number')(value, 2);
            }
        }
    }
})();
